<template>
  <div>
    <b-card-actions title="Ajouter une sous catégorie" action-collapse>
      <b-row>
        <b-col md="5">
          <vue-autosuggest
            v-model="query"
            :suggestions="suggestions"
            :input-props="inputProps"
            :section-configs="sectionConfigs"
            :render-suggestion="renderSuggestion"
            :limit="10"
            @input="fetchResults"
            @focus="fetchResults"
            @select="fetchResults"
          />
        </b-col>
        <b-col md="6">
          <b-form-group>
            <!-- <label>Nom du catégorie:</label> -->
            <b-form-input
              placeholder="Nom du sous catégorie"
              type="text"
              class="d-inline-block"
              v-model="subCategory.label"
            />
          </b-form-group>
        </b-col>
        <b-col md="1">
          <b-button variant="gradient-primary" @click="addSubCategory()">
            <feather-icon icon="SaveIcon" />
          </b-button>
        </b-col>
      </b-row>
    </b-card-actions>
    <b-card-actions title="Liste des sous catégories" action-collapse>
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">Search</label>
            <b-form-input
              placeholder="Search"
              type="text"
              class="d-inline-block"
              @input="advanceSearch"
            />
            <b-button
              variant="gradient-danger"
              class="btn-icon btn-delete-all"
              @click="deleteAllCategory()"
            >
              <!-- :disabled='$refs["table-sub-category"].selectedRows.length>0?false:true' -->

              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </b-form-group>
      </div>
      <!-- table -->
      <vue-good-table
         ref="table-sub-category"
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :select-options="{
          enabled: true,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
          selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
        :group-options="{
          enabled: true,
        }"
        theme="my-theme"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Action -->
          <!-- <span v-if="props.column.label === 'Agent de saisie'">
               John Doe
             </span> -->
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  @click="UpdateSubCategoryModal(props.row)"
                  v-b-modal.modal-categorie
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Modifier</span>
                </b-dropdown-item>
                <b-dropdown-item @click="DeleteSubCategory(props.row._id)">
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Supprimer</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Afficher 1 à </span>
              <b-form-select
                v-model="pageLength"
                :options="['3', '5', '10']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> sur {{ props.total }} résultats </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </b-card-actions>
    <!-- update modal -->
    <b-modal
      v-model="show"
      id="modal-categorie"
      cancel-variant="outline-secondary"
      ok-title="categorie"
      cancel-title="Close"
      centered
      title="Modifier sous catégorie"
    >
      <b-form>
        <b-form-group>
          <label for="label">Nom du sous catégorie:</label>
          <b-form-input
            id="label"
            type="text"
            placeholder="Nom du sous catégorie"
            v-model="updateSubCategory.label"
          />
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="warning"
            size="md"
            @click="
              UpdateSubCategory();
              show = false;
            "
          >
            Modifier
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BAvatar,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BRow,
  BCol,
  BButton,
  BCardText,
  BModal,
  VBModal,
  BForm,
  BDropdown,
  BDropdownItem,
  BTooltip,
} from "bootstrap-vue";
import { VueAutosuggest } from "vue-autosuggest";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
import store from "@/store/index";
import axios from "axios";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    BTooltip,
    BCardActions,
    VueAutosuggest,
    Ripple,
    BButton,
    BCardText,
    VueGoodTable,
    BAvatar,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BForm,
    BModal,
    VBModal,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      datasuggest: [],
      query: "",
      suggestions: [],
      selected: null,
      inputProps: {
        id: "autosuggest__input",
        class: "form-control",
        placeholder: "Nom du catégorie",
      },
      sectionConfigs: {
        Categorie: {
          limit: 6,
          label: "Categorie",
          onSelected: (selected) => {
            this.selected = selected.item;
          },
        },
      },
      idUpdateSubcategory: "",
      updateSubCategory: {
        category: "",
        label: "",
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
      },
      filteredOptions: [],
      limit: 10,
      subCategory: {
        category: "",
        label: "",
        createdBy: JSON.parse(localStorage.getItem("userData"))._id,
      },
      pageLength: 5,
      dir: false,
      columns: [
          {
          label: "Action",
          field: "action",
          sortable: false,
        },
        {
          label: "Nom du sous catégorie",
          field: "label",
        },
        {
          label: "Date de création",
          field: "createdAt",
          formatFn: this.dateFormat,
        },
        {
          label: "Dernière modification",
          field: "updatedAt",
          formatFn: this.dateFormat,
        },
        {
          label: "Agent de saisie",
          field: "createdBy",
          formatFn: this.nameFormat,
        }
      ],
      rows: [],
      searchTerm: "",
      show: false,
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
    this.getAllDataCategory();
  },
  methods: {
    // get all category with sub category
    getAllDataCategory() {
      axios
        .get("https://management-projects.herokuapp.com/api/categories")
        .then((response) => {
          var subCategoryToDisplay = [];
          var subCategoryToDisplay = response.data.map((element) => {
            // if (element.subCategories.length > 0) {
            var newObjTable = {
              mode: "span",
              html: false,
              label: element.label,
              children: element.subCategories.map((subCategory) => {
                return {
                  _id: subCategory._id,
                  createdBy: element.createdBy != null ? element.createdBy : '',
                  label: subCategory.label,
                  createdAt: subCategory.createdAt,
                  updatedAt: subCategory.updatedAt,
                };
              }),
            };
            return newObjTable;
            // }
          });
          console.log("subCategoryToDisplay",subCategoryToDisplay);
          // add subcatégorie input
          var newObjSelect = [
            {
              Category: [],
            },
          ];
          newObjSelect[0].Category = response.data.map((element) => {
            var newObj = {
              id: element._id,
              name: element.label,
            };
            return newObj;
          });
          this.rows = subCategoryToDisplay;
          this.datasuggest = newObjSelect;
        })
        .catch((error) => {
          this.errorMessage = error.message;
        });
    },
    // add category
    addSubCategory() {
      this.subCategory.categories = [this.selected.id];
      if (this.subCategory.label != "") {
        axios
          .post(
            "https://management-projects.herokuapp.com/api/sub-categories",
            this.subCategory
          )
          .then((response) => {
            this.subCategory.label = "";
            this.getAllDataCategory();
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Sous catégorie bien ajoutée`,
                icon: "UserIcon",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.log(this.errorMessage);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `Erreur lors de l'ajout`,
                icon: "UserIcon",
                variant: "danger",
              },
            });
          });
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `Erreur lors de l'ajout`,
            icon: "UserIcon",
            variant: "danger",
          },
        });
      }
    },
    // delete category
    DeleteSubCategory(id) {
      this.$swal({
        title: "vous voulez vraiment supprimer cette sous catégorie ?",
        text: "Vous ne pourrez pas annuler cela!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmer !",
        cancelButtonText: "Annuler !",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .delete(
              `https://management-projects.herokuapp.com/api/sub-categories?ids=${id}&deletedBy=${
                JSON.parse(localStorage.getItem("userData"))._id
              }`
            )
            .then((response) => {
              this.getAllDataCategory();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `sous catégorie bien supprimé`,
                  icon: "UserIcon",
                  variant: "success",
                },
              });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Erreur lors de la suppression`,
                  icon: "UserIcon",
                  variant: "danger",
                },
              });
              this.errorMessage = error.message;
              console.log(this.errorMessage);
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Action annulée",
            icon: "error",
            confirmButtonText: "Fermer !",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    // delete many sub category
      deleteAllCategory() {
      var deleteIds = [];
      this.$refs["table-sub-category"].selectedRows.forEach((element) => {
        deleteIds.push(element._id);
      });
      console.log(deleteIds, this.$refs["table-sub-category"].selectedRows);
      axios
        .delete(
          `https://management-projects.herokuapp.com/api/sub-categories?ids=${deleteIds.join(
            ","
          )}&deletedBy=${JSON.parse(localStorage.getItem("userData"))._id}`
        )
        .then((response) => {
          this.getAllDataCategory();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Sous catégorie bien supprimé`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la suppression`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    // modal update sub category
    UpdateSubCategoryModal(category) {
      this.idUpdateSubcategory = category._id;
      this.updateSubCategory.label = category.label;
      this.updateSubCategory.category = category.category;
      console.log(category);
    },
    // update sub category
    UpdateSubCategory(category) {
      axios
        .put(
          "https://management-projects.herokuapp.com/api/sub-categories/" +
            this.idUpdateSubcategory,
          this.updateSubCategory
        )
        .then((response) => {
          this.getAllDataCategory();
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Sous catégorie bien Modifié`,
              icon: "UserIcon",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `Erreur lors de la modification`,
              icon: "UserIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
          console.log(this.errorMessage);
        });
    },
    //date format
    dateFormat: function (value) {
      return new Date(value).toLocaleString();
    },
    //name format
    nameFormat: function (value) {
      if (value != null) {
        return value.firstName + " " + value.lastName;
      }
    },
    // search category
    advanceSearch(val) {
      this.searchTerm = val;
    },
    // search select category
    fetchResults(text) {
      if (this.query === "" || this.query === undefined) {
        this.suggestions = [];
        const filteredCategory = this.datasuggest[0].Category;
        this.suggestions.push({
          name: "Categorie",
          data: filteredCategory,
        });
      } else {
        this.suggestions = [];
        const filteredCategory = this.datasuggest[0].Category.filter(
          (item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1
        ).slice(0, this.limit);
        this.suggestions.push({
          name: "Categorie",
          data: filteredCategory,
        });
      }
    },
    renderSuggestion(suggestion) {
      return (
        <div class="d-flex align-items-center">
          <div class="detail">
            <b-card-text class="mb-0">{suggestion.item.name}</b-card-text>
          </div>
        </div>
      );
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>

<style>
.btn-action-table button {
  margin-left: 10px;
  margin-top: 5px;
}
.btn-action-table {
  display: flex;
}
.btn-delete-all {
  margin-left: 3%;
}
</style>
